/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/components/roles-list/roles-list.component.scss */
mat-list-item:hover .role-list-call-to-action,
.mat-mdc-list-item:hover .role-list-call-to-action {
  visibility: visible;
}
.role-list-call-to-action {
  visibility: hidden;
}
mat-list-item *[aria-expanded=true],
.mat-mdc-list-item *[aria-expanded=true] {
  visibility: visible;
}
/*# sourceMappingURL=roles-list.component.css.map */
